import React, { memo } from "react";

import styles from "~/nav/panels/shared/PanelSection.module.css";

interface EmptyStateProps {
	emptyStateText: string;
}

function EmptyState({ emptyStateText }: EmptyStateProps): React.ReactElement {
	return <p className={styles.emptyPanelSection}>{emptyStateText}</p>;
}

export default memo(EmptyState);
